import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/store/app.reducer';
import { selectCurrentLang } from 'src/app/store/user/user.selector';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { StandardDesignParameters, StandardMtmaLayout, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';
import { DEFAULT_LANG, LANGUAGES } from 'src/app/conf/languages';
import { Lang } from 'src/app/model/lang';
import { ActivatedRoute } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { FormGroup } from '@angular/forms';
import * as DeviceVctActions from 'src/app/store/device-vct/device-vct.actions';

@Component({
	selector: 'app-devices-vct-list-filters',
	templateUrl: './devices-vct-list-filters.component.html',
	providers: [ConfirmationService, DialogService]
})

export class DeviceVctListFiltersComponent implements OnInit {
	@Input() deviceFilters: FormGroup;

	currentLang$: Observable<Lang> = new Observable();
	currentLang: Lang = DEFAULT_LANG;
	languages = LANGUAGES;
	COLUMN_TITLE_MIN_WD = 647;

	screenWidth: number;
	MAX_MD_WIDTH = StandardDesignParameters.MAX_MD_WIDTH;
	LG_WIDTH = StandardDesignParameters.LG_WIDTH;

	constructor(
		private store: Store<AppState>,
		public confirmationService: ConfirmationService,
		private route: ActivatedRoute,
		private translate: TranslateService,
		public dialogService: DialogService,
		public app: AppComponent
	) {
		this.initSelectors();
	}

	ngOnInit() {
		this.subscribeAll();
		this.onResize();
	}


	initSelectors(): void {
		// Store selectors
		this.currentLang$ = this.store.select(selectCurrentLang);
	}

	subscribeAll(): void {
		this.currentLang$?.subscribe((lang: Lang) => {
			this.currentLang = lang;
		});
	}

	enableMaximumSharingSystem(): void {
		this.store.dispatch(DeviceVctActions.massiveVctInvitationsReset());
		this.store.dispatch(DeviceVctActions.enableEditSystem({ editSystem: true }));
	}

	// Design
	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	underTablet(): boolean {
		return StandardPageLayout.underTablet(this.screenWidth);
	}

	underMinWidthCol4(): boolean {
		return StandardPageLayout.underMinWidthCol4(this.screenWidth);
	}

	layoutMarginResponsive(): string {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}

	colFilterResponsive(elemType: string): string {
		return StandardPageLayout.colFilterResponsive(this.screenWidth, elemType);
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-20rem');
	}

	tabletUnderLgWidth(): boolean {
		return StandardPageLayout.tabletUnderLgWidth(this.screenWidth);
	}

	actionLayout(position: string): string {
		return StandardMtmaLayout.actionLayout(this.screenWidth, position);
	}
}
